module.exports = __webpack_public_path__ + "static/media/education.1b226605.jpg";